var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgExit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.54248 15.3965L6.89603 15.75L12.896 21.75C13.0913 21.9453 13.4079 21.9453 13.6031 21.75C13.7984 21.5548 13.7984 21.2382 13.6031 21.0429L8.45669 15.8965L20.2496 15.8965C20.5258 15.8965 20.7496 15.6726 20.7496 15.3965C20.7496 15.1203 20.5258 14.8965 20.2496 14.8965L8.45669 14.8965L13.6031 9.75004C13.7984 9.55477 13.7984 9.23819 13.6031 9.04293C13.4079 8.84767 13.0913 8.84767 12.896 9.04293L6.89603 15.0429L6.54248 15.3965ZM19.7496 25.3965C19.7496 25.1203 19.9735 24.8965 20.2496 24.8965L24.2496 24.8965C25.0781 24.8965 25.7496 24.2249 25.7496 23.3965L25.7496 7.39648C25.7496 6.56806 25.0781 5.89648 24.2496 5.89648L20.2496 5.89648C19.9735 5.89648 19.7496 5.67263 19.7496 5.39648C19.7496 5.12034 19.9735 4.89648 20.2496 4.89648L24.2496 4.89648C25.6304 4.89648 26.7496 6.01577 26.7496 7.39648L26.7496 23.3965C26.7496 24.7772 25.6304 25.8965 24.2496 25.8965L20.2496 25.8965C19.9735 25.8965 19.7496 25.6726 19.7496 25.3965Z"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgExit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/exit.bccce16b14cc974a4f7e23647a251ea8.svg";